import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <div>
        <div className="note">
          *** Note : Warning level for rainfall (mm): 60 mm in 1 hr, 80 mm in 3 hr, 100 mm in 6 hr, 120 mm in 12 hr, 140
          mm in 24 hr. This indicates potential threat for landslides in steep slope and high flow in local areas
          {/*<span className="powered">Powered by<a href="http://wscada.com" className="wscada">WSCADA.com</a></span>*/}
        </div>
      </div>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Watch/WatchFooter.js